import { h } from "omi";

export function HeartsGraphic() {
  return (
    <svg width="89" height="70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M8.9657 24.9199c-2.703-.0659-5.1422-.7252-7.6473-1.8459M10.7463 34.3474c-2.0437-.0659-4.0874-.1318-6.131.0659M11.8657 42.1926c-1.4504.3956-2.703.7911-3.9555 1.5822M36.5637 32.3328c-1.1867 26.8978-21.4919-4.9444-19.2504-14.7015 1.8459-7.911 10.68 5.6697 11.537 7.8452.2637.6593-.2637-1.4504-.3955-2.1755a44.9951 44.9951 0 0 1-.5934-4.1534c-.4615-3.4281-.5933-12.1303 5.2741-8.3066 6.3948 4.1533 4.0215 17.6681 3.1645 23.9311M66.6708 62.4532c-8.043 12.8555-10.4163-.1319-11.1415-8.1089-1.1208-12.3282-6.9222-36.3252-.3956-47.3348 2.3074-3.8897 6.1971-1.5163 7.8452 1.4503 3.7578 6.5267 1.9778 14.1741 4.7467 20.6349.3955.9229.7251-1.9119 1.0548-2.8349.7252-1.9118 1.3845-3.8237 2.0437-5.7355 1.7141-5.0104 2.9667-20.503 11.2075-19.1185 12.5259 2.1096 1.714 26.8977-.923 33.4244M81.5512 34.9407c-3.626 5.6696-11.2075 21.9533-14.9653 28.3481"
        stroke="currentColor"
        strokeWidth="2"
        strokeMiterlimit="1.5"
        strokeLinecap="round"
      />
    </svg>
  );
}
